export const COMMENT_API_URL = `${process.env.MIX_COMMENT_API_URL}`;
export const IMAGE_STORAGE_URL = `${process.env.MIX_IMAGE_STORAGE_URL}`;
export const CHATBOX_SERVICE_URL = `${process.env.MIX_CHATBOX_SERVICE_URL}`;
export const API_CHATBOX_URL = `${process.env.MIX_API_CHATBOX_URL}`;
export const API_LIVE_URL = `${process.env.MIX_API_LIVE_URL}`;
export const API_FOOTBALL_URL = `${process.env.MIX_API_FOOTBALL_URL}`;
export const API_BASKETBALL_URL = `${process.env.MIX_API_BASKETBALL_URL}`;
export const API_TENNIS_URL = `${process.env.MIX_API_TENNIS_URL}`;
export const API_BADMINTON_URL = `${process.env.MIX_API_BADMINTON_URL}`;
export const API_VOLLEYBALL_URL = `${process.env.MIX_API_VOLLEYBALL_URL}`;
export const API_BASEBALL_URL = `${process.env.MIX_API_BASEBALL_URL}`;
export const API_ESPORTS_URL = `${process.env.MIX_API_ESPORTS_URL}`;
export const API_XL_SCORE_URL = `${process.env.MIX_API_XL_SCORE_URL}`;
export const API_OPT_SEARCH_SCORE_URL = `${process.env.MIX_API_OPT_SEARCH_SCORE_URL}`;

export const EVENT_ODDS_LIVE_DATA_UPDATED = 'ODDS_LIVE_DATA_UPDATED';
